/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTractorEquipType.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/tractor-equip-type";

export class AutogenModelTractorEquipType<RowType extends ModelRow> extends Endpoint<RowType, RowTractorEquipTypeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTractorEquipType extends ModelRow<RowTractorEquipTypeFields> {
	constructor(values?: Partial<RowTractorEquipTypeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTractorEquipTypeFields {
	applies_to: string;
	company_id: string;
	descr: string;
	equip_length: number;
	equip_width: number;
	exchange_type: string;
	fms_length: string;
	fms_type: string;
	id: string;
	picture_resource: string;
	pnn_code_id: string;
	web_order: number;
}

